import React, { createContext, useContext, useState, useEffect } from 'react';
import { TRANSLATIONS } from './lang';

const STORAGE_KEY = 'portfolio-lang';
const LangContext = createContext(null);

const META_DESC = {
  fr: "Portfolio de TRAORE Lamine, développeur Fullstack senior : 5+ ans d'expérience, Next.js, NestJS, Laravel, Flutter. Basé à Abidjan, Côte d'Ivoire — disponible en remote, freelance ou CDI.",
  en: "Portfolio of TRAORE Lamine, senior fullstack developer: 5+ years of experience with Next.js, NestJS, Laravel, Flutter. Based in Abidjan, Côte d'Ivoire — available remotely, freelance or full-time.",
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const s = localStorage.getItem(STORAGE_KEY);
      if (s === 'fr' || s === 'en') return s;
    } catch {}
    return 'fr';
  });

  // Keep the document language honest for search engines & screen readers.
  useEffect(() => {
    document.documentElement.lang = lang;
    document.querySelector('meta[name="description"]')?.setAttribute('content', META_DESC[lang]);
  }, [lang]);

  const toggleLang = () => {
    setLang((l) => {
      const next = l === 'fr' ? 'en' : 'fr';
      try { localStorage.setItem(STORAGE_KEY, next); } catch {}
      return next;
    });
  };

  return (
    <LangContext.Provider value={{ lang, toggleLang, t: TRANSLATIONS[lang] }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
